import React, { FC, MouseEvent, ReactNode } from 'react'
import styled from 'styled-components'

import { ResponsiveSize } from '@/components/atomic/_enums'
import Button from '@/components/cell/molecules/Button'

type ButtonColor = 'primary' | 'secondary' | 'tertiary' | 'action'
type ButtonSize = 'small' | 'medium' | 'large'

const BlockButtonWrapper = styled.div`
  width: 100%;
  text-align: center;

  & > button {
    width: 100%;
    svg {
      vertical-align: sub;
    }
  }
  @media screen and (max-width: ${ResponsiveSize.TABLET_MAX_WIDTH}px) {
    & > button {
    }
  }
`

interface BlockButtonProps {
  color: ButtonColor
  size: ButtonSize
  className?: string
  children?: ReactNode
  onClick?: (e: MouseEvent) => void
}
const BlockButton: FC<BlockButtonProps> = ({ color = 'action', size = 'medium', onClick, className, children }) => {
  return (
    <BlockButtonWrapper className={className}>
      <StyledButton color={color} size={size} onClick={onClick}>
        {children}
      </StyledButton>
    </BlockButtonWrapper>
  )
}

const StyledButton = styled(Button)`
  height: 36px;
`

export { BlockButton }
